import * as React from 'react'

function SvgBreadcrumbSeparator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M9 5l7 7-7 7" />
    </svg>
  )
}

export default SvgBreadcrumbSeparator
